/**
 * Returns service name with nickname if it is existed and different from name
 * @param name {string}
 * @param nickname {string|null|undefined}
 * @returns {string}
 */
export const getServiceNameWithNickname = (name, nickname) => {
  if (!nickname || nickname === name) {
    return name;
  }

  return `${nickname} (${name})`;
}